// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:40.420Z
// Property: Sheridan Pond (ID: 6767906449165625)
// Collections: 23 amenities, 12 floorplans (live), 36 photos, 68 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165625",
  "property_external_id": "5vlhdrq",
  "property_zillow_url": "https://www.zillow.com/apartments/tulsa-ok/sheridan-pond/5XhzVw/",
  "property_apartments_url": "https://www.apartments.com/sheridan-pond-tulsa-ok/5vlhdrq/",
  "property_google_business_url": "https://www.google.com/maps/place/Sheridan+Pond/data=!4m2!3m1!1s0x0:0x17dfb5a0305f92bf?sa=X&ved=2ahUKEwjaz4Oj_7ySAxXjlmoFHVI2FscQ_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "sheridan-pond",
  "property_name": "Sheridan Pond",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/sheridan-pond/",
  "property_domain": null,
  "property_address": "8130 South Lakewood Place",
  "property_full_address": "8130 South Lakewood Place, Tulsa, OK, 74137",
  "property_address_1": "8130 South Lakewood Place",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74137",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0448",
  "property_address_longitude": "-95.906",
  "property_email": "sheridanpond@caseusa.com",
  "property_phone": "(539) 234-6696",
  "property_call_tracking_phone": "844-685-0696",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Nestled in the heart of Tulsa, Sheridan Pond offers stylish one, two, and three-bedroom apartments that redefine comfort. With amenities like a sparkling pool, modern fitness center, and serene pond views, your perfect sanctuary awaits. Walk into luxury—schedule a tour or check availability today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Sheridan Pond, your perfect oasis in the heart of Tulsa, Oklahoma! Our vibrant apartment community offers a variety of thoughtfully designed floor plans, including spacious one-bedroom, two-bedroom, and three-bedroom layouts, tailored to meet your lifestyle needs. Enjoy an array of top-notch amenities that elevate your living experience. Dive into relaxation at our sparkling pool or stay active at our fully-equipped fitness center. For those seeking convenience, we offer furnished units and a proactive package service.\n\nAt Sheridan Pond, we understand the value of community. Gather with friends in our inviting clubhouse, or challenge your neighbors to a game on our basketball and tennis courts. Our gated environment ensures peace of mind, while the serene pond provides a picturesque backdrop for leisurely strolls. Additionally, with high-speed internet access, a business center, and ample storage space, you will find everything you need right at your fingertips.\n\nYour comfort is our priority, which is why every apartment features modern appliances, including a washer and dryer, dishwasher, and microwave, along with beautiful options like vaulted ceilings, walk-in closets, and cozy fireplaces. Embrace outdoor living with your personal balcony or patio, perfect for enjoying the scenic views.\n\nDon’t wait to make Sheridan Pond your new home! Explore our availability today or schedule a tour to experience firsthand all that our community has to offer. Find your perfect sanctuary at Sheridan Pond today!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb46-fb44-7613-871b-7f058d55ba3c.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a city street with buildings and trees.",
    "public_id": "019cfb46-fb44-7613-871b-7f058d55ba3c",
    "storage_key": "property/6767906449165625/019cfb46-fb44-7613-871b-7f058d55ba3c.webp",
    "width": 1024,
    "height": 576
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs allowed. Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs allowed. Maximum of 2 pets per unit. One‑time pet fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://sheridanpondapartmentstulsa.securecafe.com/onlineleasing/sheridan-pond/floorplans.aspx",
  "property_resident_portal_url": "https://sheridanpondapartmentstulsa.securecafe.com/residentservices/sheridan-pond/userlogin.aspx",
  "property_apply_now_url": "https://sheridanpondapartmentstulsa.securecafe.com/onlineleasing/sheridan-pond/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb46-e70a-771e-97ee-35328ad1fd33.webp",
  "property_primary_logo_media": {
    "alt_text": "Sheridan Pond Apartments & Guest Suites logo",
    "public_id": "019cfb46-e70a-771e-97ee-35328ad1fd33",
    "storage_key": "property/6767906449165625/019cfb46-e70a-771e-97ee-35328ad1fd33.webp",
    "width": 300,
    "height": 70
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-d7c6-7759-bb59-bbe4f91b16d6.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb47-d7c6-7759-bb59-bbe4f91b16d6",
    "storage_key": "property/6767906449165625/019cfb47-d7c6-7759-bb59-bbe4f91b16d6.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-e308-70bd-a5f8-3f40adf2bb08.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sheridan Pond Apartments & Guest Suites logo",
    "public_id": "019cfb47-e308-70bd-a5f8-3f40adf2bb08",
    "storage_key": "property/6767906449165625/019cfb47-e308-70bd-a5f8-3f40adf2bb08.webp",
    "width": 300,
    "height": 70
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-eb47-75f9-b285-7d56283919da.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sheridan Pond Apartments & Guest Suites logo.",
    "public_id": "019cfb47-eb47-75f9-b285-7d56283919da",
    "storage_key": "property/6767906449165625/019cfb47-eb47-75f9-b285-7d56283919da.webp",
    "width": 300,
    "height": 70
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#650004",
  "property_secondary_color": "#96acc9",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "547 - 957",
  "property_sqft_min": "547",
  "property_sqft_max": "957",
  "property_price_range": "899 - 1269",
  "property_price_min": "899",
  "property_price_max": "1269",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/SheridanPondTulsa/photos/d41d8cd9/1474190571376477/",
  "property_instagram_url": "https://www.instagram.com/sheridanpond/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJR8_c2A6StocRv5JfMKC13xc",
  "property_youtube_url": "https://www.youtube.com/watch?v=7xjd7Ak9ql0",
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=sheridan-pond-tulsa",
  "property_tiktok_url": "https://www.tiktok.com/@sheridan.pond.apartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sheridan Pond",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Sheridan Pond, where modern living meets tranquil beauty in Tulsa, Oklahoma. Choose from spacious one, two, and three-bedroom floor plans, complete with luxurious amenities like a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Unwind in stylish comfort, and enjoy the perfect blend of convenience and leisure.",
  "property_home_floorplans_blurb": "At Sheridan Pond in Tulsa, Oklahoma, your ideal living space awaits. Embrace comfort and style with our thoughtfully designed one, two, and three-bedroom apartments. Each floor plan is crafted for modern living. Browse our available homes and step into a lifestyle of convenience and tranquility today!",
  "property_home_gallery_blurb": "At Sheridan Pond in Tulsa, Oklahoma, your ideal home awaits with spacious one, two, and three-bedroom layouts. Enjoy resort-style amenities like a shimmering pool, modern fitness center, and serene pond views. Picture yourself unwinding on your balcony, surrounded by comforts tailored just for you. Welcome to effortless living!",
  "property_home_neighborhood_blurb": "Welcome to Sheridan Pond in Tulsa, where your new home is just steps from vibrant parks like Haikey Creek and Rhema. With one to three-bedroom floor plans, enjoy easy access to local favorites like the Oklahoma Aquarium and Urban Air Trampoline Park. Embrace a lifestyle filled with adventure and convenience!",
  "property_home_reviews_blurb": "At Sheridan Pond in Tulsa, residents cherish a community where service shines. With a dedicated maintenance team who responds swiftly—think \"issue resolved in just 30 minutes\"—and personal touches like warm, professional interactions, you’ll feel right at home. Join us and see what our residents have to say!",
  "property_neighborhood_blurb": "Nestled in vibrant Tulsa, Sheridan Pond offers the perfect blend of comfort and convenience. Enjoy easy access to renowned educational institutions like Oral Roberts University and Tulsa Community College, as well as outdoor escapes at nearby parks like Haikey Creek and Rhema. Uncover a lifestyle that balances city living with nature's tranquility.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sheridan Pond in Tulsa, Oklahoma, life unfolds within expertly designed living spaces, ranging from cozy one-bedroom retreats to expansive three-bedroom homes. Enjoy resort-style amenities, including a refreshing pool, state-of-the-art fitness center, and serene outdoor areas perfect for relaxation. Embrace the vibrant community atmosphere you’ve always dreamed of!",
  "property_applynow_blurb": "At Sheridan Pond in Tulsa, you’ll find one-, two-, and three-bedroom apartments thoughtfully designed for your lifestyle. Enjoy resort-style amenities like a sparkling pool, fitness center, and inviting clubhouse. With a serene pond and tennis courts, your new home is a sanctuary. Find your perfect match and lease online today!",
  "property_contactus_blurb": "At Sheridan Pond in Tulsa, Oklahoma, we offer spacious one, two, and three-bedroom floor plans designed for your lifestyle. Each layout maximizes comfort and style, providing the perfect retreat. Have questions? Reach out to our leasing team today and let us help you find your ideal home!",
  "property_faqs_blurb": "At Sheridan Pond in Tulsa, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom apartment floor plans that cater to your lifestyle. For any queries about our community, our Frequently Asked Questions page is your go-to resource. Dive in and find the answers you seek today!",
  "property_floorplans_blurb": "Welcome to Sheridan Pond in Tulsa, Oklahoma, where comfort meets style. Our thoughtfully designed floor plans—choose from one, two, or three bedrooms—cater to every lifestyle. Whether you seek cozy solitude or ample space for family, each apartment is a haven of tranquility. Browse our available options and find your perfect fit!",
  "property_gallery_blurb": "At Sheridan Pond in Tulsa, Oklahoma, envision your ideal lifestyle surrounded by stunning amenities. From cozy one-bedroom retreats to spacious three-bedroom homes, every unit offers modern comforts. Enjoy sunny days at the pool, energizing workouts in the fitness center, and serene evenings on your balcony. Picture yourself living here!",
  "property_interactivemap_blurb": "At Sheridan Pond in Tulsa, embrace life in stunning one, two, or three-bedroom apartments tailored to your lifestyle. Enjoy resort-style amenities like a shimmering pool and vibrant fitness center, all while savoring the tranquility of our scenic pond. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Sheridan Pond in Tulsa, OK, your furry friends are more than welcome! Enjoy spacious apartments where pets feel right at home. With a maximum of two pets per unit, a one-time pet fee, and minimal monthly rent, life here is as cozy for your pets as it is for you.",
  "property_referafriend_blurb": "At Sheridan Pond in Tulsa, Oklahoma, we celebrate the bond of friendship—because great friends make great neighbors! With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. Invite a friend to share your vibrant community and enjoy life’s journey together. Refer a friend today!",
  "property_residentaccess_blurb": "At Sheridan Pond in Tulsa, Oklahoma, your next home awaits with thoughtfully designed one, two, and three-bedroom floor plans. Enjoy seamless living with exclusive access to our resident portal—where paying rent and scheduling maintenance is just a click away. Elevate your lifestyle today!",
  "property_reviews_blurb": "At Sheridan Pond in Tulsa, residents cherish a peaceful lifestyle and responsive maintenance. One recent review highlights that \"maintenance was taken care of within 30 minutes,\" showcasing our commitment to excellence. Join a community where comfort thrives and residents feel at home. Ready to hear more? Don’t miss our resident testimonials!",
  "property_created_at": "1753982391344",
  "property_scheduletour_blurb": "At Sheridan Pond in Tulsa, Oklahoma, we offer spacious one, two, and three-bedroom apartments designed for your comfort and lifestyle. Each floor plan harmonizes modern amenities with serene living. Curious about life here? Schedule a tour today and see what our residents love about their home at Sheridan Pond!",
  "property_thankyou_blurb": "Thank you for reaching out to Sheridan Pond in Tulsa, Oklahoma! With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. A dedicated team member will connect with you soon to help you take the next steps toward abundant living in our vibrant community.",
  "property_virtualtours_blurb": "Welcome to Sheridan Pond in Tulsa, Oklahoma, where comfort meets style. Our thoughtfully designed one, two, and three-bedroom apartments offer a perfect sanctuary for every lifestyle. Embrace the beauty of community living—take a virtual tour today and envision your new home in this picturesque setting!",
  "property_copyright": "2025 All Rights Reserved. Sheridan Pond",
  "property_seo_title_home": "Sheridan Pond |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Welcome to Sheridan Pond in Tulsa! Our vibrant community offers one to three-bedroom apartments with top-notch amenities like a pool, fitness center, and more.",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Sheridan Pond in Tulsa! Choose from one, two, or three-bedroom layouts designed for comfort. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover Sheridan Pond in Tulsa! Enjoy luxury amenities, including a refreshing pool and a fully-equipped fitness center.",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Step into Sheridan Pond in Tulsa, OK, where stunning views meet modern amenities. Picture your life surrounded by pools, courts, and cozy retreats.",
  "property_seo_title_virtualtours": "Virtual Tours | Sheridan Pond Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Sheridan Pond in Tulsa. Take a virtual tour of our spacious one, two, and three-bedroom apartments, where comfort meets style.",
  "property_seo_title_interactivemap": "Interactive Map | Sheridan Pond Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Sheridan Pond in Tulsa, OK! Use our interactive map to explore spacious floor plans, premium amenities, and make your move today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Sheridan Pond in Tulsa! Immerse yourself in the vibrant neighborhood with local favorites and hidden gems just steps from home.",
  "property_seo_title_contact": "Contact Us | Sheridan Pond",
  "property_seo_description_contact": "Reach out to Sheridan Pond in Tulsa for inquiries about our spacious one, two, and three-bedroom apartments. Our leasing team is ready to assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Sheridan Pond in Tulsa! From floor plans to amenities, our FAQs page has you covered for a seamless living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Experience life at Sheridan Pond in Tulsa! From spacious floor plans to endless amenities, hear what our residents love most about their home here!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Join Sheridan Pond in Tulsa! Enjoy spacious apartments, great amenities, and serene pond views. Apply online today for your new home!",
  "property_seo_title_residentaccess": "Resident Access | Sheridan Pond",
  "property_seo_description_residentaccess": "Unlock your Sheridan Pond experience! Log in to your resident portal for easy rent payments, hassle-free maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Sheridan Pond",
  "property_seo_description_referafriend": "Share the joy of living at Sheridan Pond! Refer a friend and help them find their perfect home in Tulsa, where great friends become great neighbors.",
  "property_seo_title_scheduletour": "Schedule a Tour | Sheridan Pond",
  "property_seo_description_scheduletour": "Experience the charm of Sheridan Pond in Tulsa. Join us for a tour and envision your new home surrounded by serene landscapes and vibrant community life!",
  "property_seo_title_privacy": "Privacy Policy | Sheridan Pond",
  "property_seo_description_privacy": "Your peace of mind matters at Sheridan Pond. Read our privacy policy to see how we protect your personal information—your trust is our priority!",
  "property_seo_title_accessibility": "Website Accessibility | Sheridan Pond",
  "property_seo_description_accessibility": "At Sheridan Pond in Tulsa, we prioritize digital inclusion with accessible features for all residents. Experience community living like never before!",
  "property_seo_title_sitemap": "Sitemap | Sheridan Pond",
  "property_seo_description_sitemap": "Navigate Sheridan Pond in Tulsa, where modern living meets serene surroundings. Find your perfect apartment and explore our community today!",
  "property_seo_title_thankyou": "Thank You | Sheridan Pond",
  "property_seo_description_thankyou": "Thank you for reaching out to Sheridan Pond in Tulsa! Your inquiry is important to us—our team will connect with you shortly to assist you further.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865752604",
  "amenities": [
    {
      "id": "ec_3c785d58b3cec6b04bc43ac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397111",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5504d3abafd994caa04e465",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397113",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ffc4e0b69b573abc319a63e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397114",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffa41078530372578d755cf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397115",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78011f75c6e9a9f31a7ae824",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397116",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3715c004f5cc8f766883806f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397117",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cf608c9f127fc2c04d07a68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397118",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8e3a7072bea2d2ff2a10569",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397119",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1117ae3925b23c720bc3d8b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397121",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4731cdc7b3060edb1ef9e505",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127397123",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b24f82f6b41388a024780488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "128042553",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_576803f69e02a4913f098fd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "128017308",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba83adcb88506ec683c0f9bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398573",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00e3ab26ab1dc8735f51e044",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398574",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3fdc9362e90fafa56311b3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398575",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_911d1039678b711e4e3c07e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398576",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42620d6a51fc4879cb8cdd4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398577",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3b777d33ecda2ece4aedf17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398578",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_471c5691d1718599574b7655",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398579",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78654915ef122d6ec05010a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398580",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e4b795f0cace720417c2213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398581",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a66c51f366f5191fc8a66037",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398582",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5d19d85e09a0f315ff1394e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "yardi",
      "external_id": "127398583",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ff07db56-d673-4e7c-8055-090cd6468307",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-856a-752e-8c73-c5f1624a85c5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana.",
        "public_id": "01a02003-856a-752e-8c73-c5f1624a85c5",
        "storage_key": "property/6767906449165625/01a02003-856a-752e-8c73-c5f1624a85c5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a shaded cabana. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_790493e1-2d21-4254-92af-d5abfd39b678",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-7ee4-76bd-9400-526b972f3b9f.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a covered seating area.",
        "public_id": "01a02003-7ee4-76bd-9400-526b972f3b9f",
        "storage_key": "property/6767906449165625/01a02003-7ee4-76bd-9400-526b972f3b9f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and a covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c4b2f19b-4493-49fd-be3c-330b3eeca360",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-7f3e-70a8-9b1f-4b21eeb96d08.webp",
      "image_media": {
        "alt_text": "Wooden deck overlooking a pond with outdoor seating and a pavilion.",
        "public_id": "01a02003-7f3e-70a8-9b1f-4b21eeb96d08",
        "storage_key": "property/6767906449165625/01a02003-7f3e-70a8-9b1f-4b21eeb96d08.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the beautiful scenery and fresh air on the wooden deck, perfect for relaxing or gathering with friends. Featuring comfortable outdoor seating and a shaded pavilion.",
      "link": "",
      "alt_text": "Wooden deck overlooking a pond with outdoor seating and a pavilion.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a28e93f1-f0a5-4aab-82bc-56b62f00712c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-7e75-741a-bf82-821f171b3b58.webp",
      "image_media": {
        "alt_text": "Tennis courts and basketball court with fencing and trees.",
        "public_id": "01a02003-7e75-741a-bf82-821f171b3b58",
        "storage_key": "property/6767906449165625/01a02003-7e75-741a-bf82-821f171b3b58.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our tennis courts and basketball court, perfect for staying active and having fun.",
      "link": "",
      "alt_text": "Tennis courts and basketball court with fencing and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ffb659f-6049-4e7c-8cfe-1562361e4e20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-7dcf-74f9-864d-a6cf65cc778b.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and sun deck area next to a body of water.",
        "public_id": "01a02003-7dcf-74f9-864d-a6cf65cc778b",
        "storage_key": "property/6767906449165625/01a02003-7dcf-74f9-864d-a6cf65cc778b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, or relax and soak up the sun on the spacious deck. Perfect for unwinding and enjoying the beautiful surroundings.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and sun deck area next to a body of water.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e9bd701b-ed56-4d4d-8bc3-e1ffaffa71f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-7dda-7767-896e-c0511d2b28b7.webp",
      "image_media": {
        "alt_text": "Tranquil pond with a fountain and lounge chairs by the pool.",
        "public_id": "01a02003-7dda-7767-896e-c0511d2b28b7",
        "storage_key": "property/6767906449165625/01a02003-7dda-7767-896e-c0511d2b28b7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the serene pond with a central fountain, perfect for relaxing by the pool and outdoor seating area.",
      "link": "",
      "alt_text": "Tranquil pond with a fountain and lounge chairs by the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50823c2f-1468-4a48-86b0-5d21c6f34870",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-55a3-7762-8cf3-184e8dcfa8d9.webp",
      "image_media": {
        "alt_text": "Exterior of the leasing office with a prominent brick chimney and large windows.",
        "public_id": "01a02003-55a3-7762-8cf3-184e8dcfa8d9",
        "storage_key": "property/6767906449165625/01a02003-55a3-7762-8cf3-184e8dcfa8d9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "The leasing office exterior features a charming brick chimney, expansive windows, and manicured landscaping, offering a welcoming first impression.",
      "link": "",
      "alt_text": "Exterior of the leasing office with a prominent brick chimney and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_01612a66-6af4-47f8-92fa-6e2f3b7f964c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-318c-74d1-a816-48d36ec7c1c6.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with agility equipment and apartment buildings in the background.",
        "public_id": "01a02003-318c-74d1-a816-48d36ec7c1c6",
        "storage_key": "property/6767906449165625/01a02003-318c-74d1-a816-48d36ec7c1c6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment for your furry friends, surrounded by the beautiful apartment community.",
      "link": "",
      "alt_text": "Outdoor dog park with agility equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_768b8d20-a463-4331-9551-5cd043bff917",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-f206-7712-8689-78617c61d24f.webp",
      "image_media": {
        "alt_text": "Full basketball court with fencing and trees in the background.",
        "public_id": "01a02002-f206-7712-8689-78617c61d24f",
        "storage_key": "property/6767906449165625/01a02002-f206-7712-8689-78617c61d24f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a friendly game of basketball on our outdoor court.",
      "link": "",
      "alt_text": "Full basketball court with fencing and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b93d6197-fb4c-4273-b0c6-9897e0334cd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-f287-77bc-9e5d-8a740cefdfe6.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, parking lots, and surrounding landscaping.",
        "public_id": "01a02002-f287-77bc-9e5d-8a740cefdfe6",
        "storage_key": "property/6767906449165625/01a02002-f287-77bc-9e5d-8a740cefdfe6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing apartment complex buildings, ample parking, and lush green surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, parking lots, and surrounding landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_496d6990-0592-4049-baf6-e264bbbf4610",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-f215-739e-9b88-d06c3641bcfb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, chimneys, and landscaping.",
        "public_id": "01a02002-f215-739e-9b88-d06c3641bcfb",
        "storage_key": "property/6767906449165625/01a02002-f215-739e-9b88-d06c3641bcfb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring private balconies, functional chimneys, and well-maintained landscaping, offering a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies, chimneys, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf119c35-e379-49f4-b045-0c053ff44d16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
      "image_media": {
        "alt_text": "Comfortable bedroom with a queen-size bed, nightstand with lamp, and framed art.",
        "public_id": "01a02002-a711-73a1-87a6-ff917d9fb6b4",
        "storage_key": "property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this cozy bedroom, featuring a plush queen bed, ambient lighting, and tasteful decor.",
      "link": "",
      "alt_text": "Comfortable bedroom with a queen-size bed, nightstand with lamp, and framed art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b73a9a86-45c3-47ba-bce6-92f0e2bbebdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a6e5-7679-8468-9ab9fc9e9fc1.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a sink, faucet, soap, plant, and mirror reflecting a shower curtain.",
        "public_id": "01a02002-a6e5-7679-8468-9ab9fc9e9fc1",
        "storage_key": "property/6767906449165625/01a02002-a6e5-7679-8468-9ab9fc9e9fc1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with a marble-look countertop, a stainless steel faucet, and a decorative plant. The mirror reflects the shower area.",
      "link": "",
      "alt_text": "Bathroom vanity with a sink, faucet, soap, plant, and mirror reflecting a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07348172-2a4a-462d-bdb9-a527846094eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-89e9-7699-95cc-ea09582eeeda.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sectional sofa, coffee table, accent chair, and a wall-mounted TV.",
        "public_id": "01a02002-89e9-7699-95cc-ea09582eeeda",
        "storage_key": "property/6767906449165625/01a02002-89e9-7699-95cc-ea09582eeeda.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and stylish living room featuring a comfortable gray sectional sofa, a modern coffee table, and a large window with blinds. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with a gray sectional sofa, coffee table, accent chair, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a27ed2e-8f84-48e0-88bc-8161f8e17232",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and black chairs, next to a kitchen with stainless steel appliances.",
        "public_id": "01a02002-8407-75db-af34-0494e665ff38",
        "storage_key": "property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, adjacent to a modern kitchen featuring stainless steel appliances. Perfect for everyday living.",
      "link": "",
      "alt_text": "Dining area with a round table and black chairs, next to a kitchen with stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d32bfa02-5416-4091-84cf-41ea827f490a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8890-7384-a16b-86fbda8855d9.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and dresser.",
        "public_id": "01a02002-8890-7384-a16b-86fbda8855d9",
        "storage_key": "property/6767906449165625/01a02002-8890-7384-a16b-86fbda8855d9.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a queen-size bed, ample storage, and a peaceful ambiance.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_91b70e3a-cab2-4239-a509-0a6f23007097",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
      "image_media": {
        "alt_text": "Kitchen with oak cabinets, stainless steel appliances, and a pass-through window.",
        "public_id": "01a02002-82d6-74ab-bf13-0828a33b4de4",
        "storage_key": "property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-equipped kitchen featuring ample cabinet space, stainless steel appliances including a refrigerator, oven, and microwave, and a convenient pass-through window.",
      "link": "",
      "alt_text": "Kitchen with oak cabinets, stainless steel appliances, and a pass-through window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a4638ea-c894-4912-a7e6-8d7cdffd033b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-7fd1-763a-9adb-38af731ad8b2.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with bar stools and a dining table.",
        "public_id": "01a02002-7fd1-763a-9adb-38af731ad8b2",
        "storage_key": "property/6767906449165625/01a02002-7fd1-763a-9adb-38af731ad8b2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a modern and functional kitchen space with bar seating and a separate dining area, perfect for entertaining guests or enjoying a casual meal.",
      "link": "",
      "alt_text": "Kitchen and dining area with bar stools and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97e69ada-123a-4027-8e45-8b0ccc6737e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-6342-73dd-bc18-b260e6dfa5ac.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, nightstand, and dresser.",
        "public_id": "01a02002-6342-73dd-bc18-b260e6dfa5ac",
        "storage_key": "property/6767906449165625/01a02002-6342-73dd-bc18-b260e6dfa5ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen bed, a convenient nightstand, and ample dresser storage.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19a8ac4e-dff9-4f20-b39b-1f2877592717",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-5f1e-7648-82da-3e9201bb1911.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sofa",
        "public_id": "01a02002-5f1e-7648-82da-3e9201bb1911",
        "storage_key": "property/6767906449165625/01a02002-5f1e-7648-82da-3e9201bb1911.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, television, comfortable sofa, and stylish decor, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with fireplace and sofa",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2edb7dcd-5d73-4458-a672-6a399206478d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-5ec5-76cc-95ad-e07479927f8b.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and oven in a kitchen with wood cabinets.",
        "public_id": "01a02002-5ec5-76cc-95ad-e07479927f8b",
        "storage_key": "property/6767906449165625/01a02002-5ec5-76cc-95ad-e07479927f8b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring stainless steel appliances, ample wood cabinetry, and a sleek countertop.",
      "link": "",
      "alt_text": "Stainless steel refrigerator and oven in a kitchen with wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7be77649-b4c7-4854-a019-3f13b8b87e18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-51f2-7068-8f9f-02b02993ac17.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, ample cabinet space, and a double sink.",
        "public_id": "01a02002-51f2-7068-8f9f-02b02993ac17",
        "storage_key": "property/6767906449165625/01a02002-51f2-7068-8f9f-02b02993ac17.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious and functional kitchen featuring stainless steel appliances, including a microwave and refrigerator. Enjoy ample cabinet storage and a convenient double sink for all your cooking needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, ample cabinet space, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b65da0f4-d39f-48f5-87fc-958935ec71db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-c992-764d-9ea1-4050f75cc819.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, stainless steel appliances including a microwave and refrigerator, and a double sink.",
        "public_id": "01a02001-c992-764d-9ea1-4050f75cc819",
        "storage_key": "property/6767906449165625/01a02001-c992-764d-9ea1-4050f75cc819.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wood cabinetry, modern stainless steel appliances, and a convenient double sink for all your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, stainless steel appliances including a microwave and refrigerator, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8fbbdcf2-a557-4f76-a7f1-8d755d3290de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-9b18-74c9-b3cb-b47c6e12c8b9.webp",
      "image_media": {
        "alt_text": "Living room with a curved sofa, coffee table, and a ceiling fan.",
        "public_id": "01a02001-9b18-74c9-b3cb-b47c6e12c8b9",
        "storage_key": "property/6767906449165625/01a02001-9b18-74c9-b3cb-b47c6e12c8b9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a stylish curved sofa, a modern coffee table, and a ceiling fan, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a curved sofa, coffee table, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ea51a78-9d26-472a-a21f-f3fb6cae8412",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-a7cb-72eb-a6ba-9e90ee80047a.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and closet.",
        "public_id": "01a02001-a7cb-72eb-a6ba-9e90ee80047a",
        "storage_key": "property/6767906449165625/01a02001-a7cb-72eb-a6ba-9e90ee80047a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, convenient nightstand with lamp, and ample closet space.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3a4a2c6d-5933-4763-82d0-25ec3b1e1903",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-7663-748a-9533-5e11c20b53f0.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table, fireplace, and TV.",
        "public_id": "01a02001-7663-748a-9533-5e11c20b53f0",
        "storage_key": "property/6767906449165625/01a02001-7663-748a-9533-5e11c20b53f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a modern kitchen, a cozy dining nook, a fireplace, and a mounted television, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room and kitchen area with dining table, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63d17b43-fcd8-4ae7-a1b4-2306ad68ae6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-6dc4-7175-b787-4277ff9e7b76.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and window.",
        "public_id": "01a02001-6dc4-7175-b787-4277ff9e7b76",
        "storage_key": "property/6767906449165625/01a02001-6dc4-7175-b787-4277ff9e7b76.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed, a wooden dresser with a mirror, and a window with blinds and pink curtains.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1013e880-fd22-4f06-8cf6-f8ca81419b98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-8a56-7466-9401-64bea11aa827.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and double sink.",
        "public_id": "01a02001-8a56-7466-9401-64bea11aa827",
        "storage_key": "property/6767906449165625/01a02001-8a56-7466-9401-64bea11aa827.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample wooden cabinetry, a double sink, and modern stainless steel appliances for your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d28176d-125f-4b65-a6e4-fd20ab1b6afb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-7024-765a-9b8e-7e2a5ffb9ecb.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and four chairs, next to a kitchen counter.",
        "public_id": "01a02001-7024-765a-9b8e-7e2a5ffb9ecb",
        "storage_key": "property/6767906449165625/01a02001-7024-765a-9b8e-7e2a5ffb9ecb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, perfectly situated next to the kitchen for convenience. Features a stylish wooden table and chairs.",
      "link": "",
      "alt_text": "Dining area with a wooden table and four chairs, next to a kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad8dd6a6-9ec5-43ac-a5b4-83d691398f56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-8fe1-7599-8c98-4087c36b5576.webp",
      "image_media": {
        "alt_text": "Spacious living area with a large stone fireplace, comfortable seating, and floor-to-ceiling windows.",
        "public_id": "01a01fa2-8fe1-7599-8c98-4087c36b5576",
        "storage_key": "property/6767906449165625/01a01fa2-8fe1-7599-8c98-4087c36b5576.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community living space, featuring a cozy fireplace and ample natural light.",
      "link": "",
      "alt_text": "Spacious living area with a large stone fireplace, comfortable seating, and floor-to-ceiling windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e23fca8b-e53d-44c4-999a-073bccb2bc0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-8e04-7008-a0ee-afbba2bf7cdb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large island and bar stools.",
        "public_id": "01a01fa2-8e04-7008-a0ee-afbba2bf7cdb",
        "storage_key": "property/6767906449165625/01a01fa2-8e04-7008-a0ee-afbba2bf7cdb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring a large island with comfortable bar stools, perfect for casual dining and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with a large island and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6c3ff04-a5bf-4836-910d-ceecc24ab36d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-64e5-75b7-a788-6bb8a4b43dbc.webp",
      "image_media": {
        "alt_text": "Apartment gym with weight machines and treadmills.",
        "public_id": "01a01fa2-64e5-75b7-a788-6bb8a4b43dbc",
        "storage_key": "property/6767906449165625/01a01fa2-64e5-75b7-a788-6bb8a4b43dbc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with a variety of weight machines and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Apartment gym with weight machines and treadmills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c35bffd-f071-493c-9ce5-2dc7da84d3d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-392e-77ae-a832-992177c2f278.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and other exercise machines in a well-lit gym with large mirrors and windows.",
        "public_id": "01a01fa2-392e-77ae-a832-992177c2f278",
        "storage_key": "property/6767906449165625/01a01fa2-392e-77ae-a832-992177c2f278.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring state-of-the-art cardio and strength training equipment.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, and other exercise machines in a well-lit gym with large mirrors and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b16f52a8-b201-436d-92bb-750c3ecd0063",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-3a57-711d-a5b7-8a87ba7d0295.webp",
      "image_media": {
        "alt_text": "Gym with various weight machines and free weights.",
        "public_id": "01a01fa2-3a57-711d-a5b7-8a87ba7d0295",
        "storage_key": "property/6767906449165625/01a01fa2-3a57-711d-a5b7-8a87ba7d0295.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide array of cardio and strength training equipment, including weight machines and free weights.",
      "link": "",
      "alt_text": "Gym with various weight machines and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c4fd8c74-d380-4995-b878-794f692de0ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-37ad-77f1-84ea-e293259b0b5e.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace, large windows, and comfortable seating.",
        "public_id": "01a01fa2-37ad-77f1-84ea-e293259b0b5e",
        "storage_key": "property/6767906449165625/01a01fa2-37ad-77f1-84ea-e293259b0b5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community living room, featuring a cozy fireplace and ample natural light.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace, large windows, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96a2a390-8e1d-44f9-91cf-4738d4c2180e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-37ff-7539-98ca-565a585f78dc.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment community lounge with high ceilings, exposed beams, and a seating area.",
        "public_id": "01a01fa2-37ff-7539-98ca-565a585f78dc",
        "storage_key": "property/6767906449165625/01a01fa2-37ff-7539-98ca-565a585f78dc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious community lounge, featuring a modern design with exposed wooden beams, comfortable seating, and a fully equipped kitchenette area.",
      "link": "",
      "alt_text": "Interior of a modern apartment community lounge with high ceilings, exposed beams, and a seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0c51c0aa-80bb-4d19-acd3-36c2f6c25b74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-67c4-76d9-9de5-de42270ed6bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-67c4-76d9-9de5-de42270ed6bc",
        "storage_key": "property/6767906449165625/019d2709-67c4-76d9-9de5-de42270ed6bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98e7-745d-b631-fdd5dfdf9cf3",
        "storage_key": "property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a72863e5-9674-406c-bc25-a950f58e927b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-686a-75bc-868f-5ee3e0bcd9c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-686a-75bc-868f-5ee3e0bcd9c4",
        "storage_key": "property/6767906449165625/019d2709-686a-75bc-868f-5ee3e0bcd9c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98e7-745d-b631-fdd5dfdf9cf3",
        "storage_key": "property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b91afee5-c70d-44a2-a2d6-8709316bc91d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-68ee-71db-8b05-03a09c216c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-68ee-71db-8b05-03a09c216c16",
        "storage_key": "property/6767906449165625/019d2709-68ee-71db-8b05-03a09c216c16.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98e7-745d-b631-fdd5dfdf9cf3",
        "storage_key": "property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8e4a6579-3f9e-4ef0-8d6e-6d66d482cbdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-6817-758a-9422-d1849969db48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6817-758a-9422-d1849969db48",
        "storage_key": "property/6767906449165625/019d2709-6817-758a-9422-d1849969db48.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98e7-745d-b631-fdd5dfdf9cf3",
        "storage_key": "property/6767906449165625/019d2709-98e7-745d-b631-fdd5dfdf9cf3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_888e5769-1b18-4c76-97fa-d63cdf24a302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-6c25-75aa-bb24-7e07bd343aaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6c25-75aa-bb24-7e07bd343aaa",
        "storage_key": "property/6767906449165625/019d2709-6c25-75aa-bb24-7e07bd343aaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9916-7339-8349-82a51cd5c868.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9916-7339-8349-82a51cd5c868",
        "storage_key": "property/6767906449165625/019d2709-9916-7339-8349-82a51cd5c868.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2b4f3d36-7db8-45d8-bf21-e1b42f675b79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-6d25-76ce-836f-0c6423fcb7e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6d25-76ce-836f-0c6423fcb7e8",
        "storage_key": "property/6767906449165625/019d2709-6d25-76ce-836f-0c6423fcb7e8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9916-7339-8349-82a51cd5c868.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9916-7339-8349-82a51cd5c868",
        "storage_key": "property/6767906449165625/019d2709-9916-7339-8349-82a51cd5c868.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7648b98c-66cf-4536-a472-bc10098a2545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3702 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Spacious store and chain supermarket known for its affordable prices and wide variety of foods from around the world, including organic and vegan options.",
      "poi_long_description": "People say this grocery store offers a wide variety of unique items, fresh flowers, and delicious snacks. They highlight the great value, affordable prices, and clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-6d65-74e9-833e-883876f5028a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6d65-74e9-833e-883876f5028a",
        "storage_key": "property/6767906449165625/019d2709-6d65-74e9-833e-883876f5028a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/tulsa/460/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583892652892204013&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "36.1096067",
      "poi_longitude": "-95.975934",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-712-9768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98f0-75d6-a80a-7dad55ede4cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98f0-75d6-a80a-7dad55ede4cd",
        "storage_key": "property/6767906449165625/019d2709-98f0-75d6-a80a-7dad55ede4cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TxY2lOTtocR7autsmWug7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4002c253-2014-4ad5-8983-f88f848e6cc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-6e82-73ad-a410-57833ca57c5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6e82-73ad-a410-57833ca57c5b",
        "storage_key": "property/6767906449165625/019d2709-6e82-73ad-a410-57833ca57c5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98f0-75d6-a80a-7dad55ede4cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98f0-75d6-a80a-7dad55ede4cd",
        "storage_key": "property/6767906449165625/019d2709-98f0-75d6-a80a-7dad55ede4cd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2947c1e4-a93a-4e4e-b3fd-4d0b9071924c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Outdoor mall featuring Big Box stores alongside multiple restaurants and a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and convenient stores. They highlight the convenient parking, easy access, and clean facilities. They also like the variety of businesses, including an emergency hospital and EV charging stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-70e1-729f-a3e0-2ee0d281478c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-70e1-729f-a3e0-2ee0d281478c",
        "storage_key": "property/6767906449165625/019d2709-70e1-729f-a3e0-2ee0d281478c.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9916-7339-8349-82a51cd5c868.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9916-7339-8349-82a51cd5c868",
        "storage_key": "property/6767906449165625/019d2709-9916-7339-8349-82a51cd5c868.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a2d827f0-d4f0-43c5-b222-96c27036732e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7222-713d-8e6d-3e49b68b8688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7222-713d-8e6d-3e49b68b8688",
        "storage_key": "property/6767906449165625/019d2709-7222-713d-8e6d-3e49b68b8688.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98bd-7587-82f5-553fa24d8139",
        "storage_key": "property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a51cda45-d20d-45f4-b8c6-6de1295187b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7292-7448-8d78-c0bc9101fd18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7292-7448-8d78-c0bc9101fd18",
        "storage_key": "property/6767906449165625/019d2709-7292-7448-8d78-c0bc9101fd18.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98bd-7587-82f5-553fa24d8139",
        "storage_key": "property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5c643500-d7ea-477a-8299-04e4047c5ef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7375-77ab-862f-ec07337ab30c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7375-77ab-862f-ec07337ab30c",
        "storage_key": "property/6767906449165625/019d2709-7375-77ab-862f-ec07337ab30c.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98bd-7587-82f5-553fa24d8139",
        "storage_key": "property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c923c95b-c881-47ea-9238-5989123b6064",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-75bf-759e-be92-862364108db6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-75bf-759e-be92-862364108db6",
        "storage_key": "property/6767906449165625/019d2709-75bf-759e-be92-862364108db6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-98bd-7587-82f5-553fa24d8139",
        "storage_key": "property/6767906449165625/019d2709-98bd-7587-82f5-553fa24d8139.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1d7f4175-445b-48d4-8486-4ad6646e9c06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-784b-71ef-baaa-9db4945f0977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-784b-71ef-baaa-9db4945f0977",
        "storage_key": "property/6767906449165625/019d2709-784b-71ef-baaa-9db4945f0977.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_e120b9dd-85d3-4b78-9677-144c866be0a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-77fb-7291-889b-8292ca8be9ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-77fb-7291-889b-8292ca8be9ad",
        "storage_key": "property/6767906449165625/019d2709-77fb-7291-889b-8292ca8be9ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_f37db8c1-27ad-42d4-9e23-4b9474236936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7854-765f-a45e-d1bfbc894455.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7854-765f-a45e-d1bfbc894455",
        "storage_key": "property/6767906449165625/019d2709-7854-765f-a45e-d1bfbc894455.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_f91c2fb5-c7cb-46b8-b666-0b217ead1764",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7b55-77ba-80b0-a091599e764e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7b55-77ba-80b0-a091599e764e",
        "storage_key": "property/6767906449165625/019d2709-7b55-77ba-80b0-a091599e764e.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_c1696202-b157-47d8-a48a-8fb75f689c05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7c58-716e-9d00-0a1ea79bb9d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7c58-716e-9d00-0a1ea79bb9d9",
        "storage_key": "property/6767906449165625/019d2709-7c58-716e-9d00-0a1ea79bb9d9.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_c20a910b-d810-45e6-bec6-7238b8376a8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7ce1-7118-8e85-88d404bcdea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7ce1-7118-8e85-88d404bcdea4",
        "storage_key": "property/6767906449165625/019d2709-7ce1-7118-8e85-88d404bcdea4.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_12716edb-e2da-404b-a3ec-5092113efa2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-7d61-74b4-ba97-4deba2eaf3b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7d61-74b4-ba97-4deba2eaf3b5",
        "storage_key": "property/6767906449165625/019d2709-7d61-74b4-ba97-4deba2eaf3b5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ca356256-c2db-49ca-8e56-3e33ad6493dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Oklahoma Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 West 78th Street South, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8013-77d9-83c2-6c9158dd22f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8013-77d9-83c2-6c9158dd22f1",
        "storage_key": "property/6767906449165625/019d2709-8013-77d9-83c2-6c9158dd22f1.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://okvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093478136724344104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-veterinary-specialists",
      "poi_latitude": "36.0519175",
      "poi_longitude": "-96.0079484",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-299-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocRKE2sAmGrr0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ae3e0f2a-299d-45d8-9cf8-c9667d2e097f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-80ff-70b9-b117-2656cd2aff94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-80ff-70b9-b117-2656cd2aff94",
        "storage_key": "property/6767906449165625/019d2709-80ff-70b9-b117-2656cd2aff94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c3528ace-08e0-45eb-9189-0a74f69af980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-81f1-7076-ac2a-267090a82c2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-81f1-7076-ac2a-267090a82c2c",
        "storage_key": "property/6767906449165625/019d2709-81f1-7076-ac2a-267090a82c2c.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_2c41c0e3-5c78-4efc-be0a-986232331ba2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-81ff-71f9-8534-3e2b9bc81c93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-81ff-71f9-8534-3e2b9bc81c93",
        "storage_key": "property/6767906449165625/019d2709-81ff-71f9-8534-3e2b9bc81c93.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9fa01940-2842-471e-874b-48b2321a71aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8553-72fc-afc2-c84feafba5c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8553-72fc-afc2-c84feafba5c5",
        "storage_key": "property/6767906449165625/019d2709-8553-72fc-afc2-c84feafba5c5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_34b83037-0399-41ab-a5c8-0162c214fc0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8667-704a-bea5-14589d8805c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8667-704a-bea5-14589d8805c3",
        "storage_key": "property/6767906449165625/019d2709-8667-704a-bea5-14589d8805c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-734e0d22db30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-734e0d22db30",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-734e0d22db30.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fc1ad2cc-9e89-4c9d-a7c3-bdb64f51a8e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-86d4-734e-a8e6-866215f692c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-86d4-734e-a8e6-866215f692c4",
        "storage_key": "property/6767906449165625/019d2709-86d4-734e-a8e6-866215f692c4.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-734e0d22db30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-734e0d22db30",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-734e0d22db30.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f348bc60-e848-4c9a-98e1-5eba4414e1bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-86b7-701b-b2b7-41c37b93c02d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-86b7-701b-b2b7-41c37b93c02d",
        "storage_key": "property/6767906449165625/019d2709-86b7-701b-b2b7-41c37b93c02d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce0-74f7-af4a-47de1db1df3a",
        "storage_key": "property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_633d1ee1-56be-46be-9bed-fe1c7ddd8c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8a4e-7009-a864-db76ae1c4764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8a4e-7009-a864-db76ae1c4764",
        "storage_key": "property/6767906449165625/019d2709-8a4e-7009-a864-db76ae1c4764.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce0-74f7-af4a-47de1db1df3a",
        "storage_key": "property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_57a70543-5766-4f52-9cf8-3de6a4a19721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8b29-772b-8952-cd8d0b70ef2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8b29-772b-8952-cd8d0b70ef2f",
        "storage_key": "property/6767906449165625/019d2709-8b29-772b-8952-cd8d0b70ef2f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce0-74f7-af4a-47de1db1df3a",
        "storage_key": "property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7252ee88-63e5-4e0e-a249-7d8af5cb536c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8b90-73ea-b682-4a49f3ea8b7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8b90-73ea-b682-4a49f3ea8b7b",
        "storage_key": "property/6767906449165625/019d2709-8b90-73ea-b682-4a49f3ea8b7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce0-74f7-af4a-47de1db1df3a",
        "storage_key": "property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bde119d8-076f-42e7-b931-33066bf8a6de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8c3d-77a9-b0c8-be73c70dfdd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8c3d-77a9-b0c8-be73c70dfdd2",
        "storage_key": "property/6767906449165625/019d2709-8c3d-77a9-b0c8-be73c70dfdd2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce0-74f7-af4a-47de1db1df3a",
        "storage_key": "property/6767906449165625/019d2709-9ce0-74f7-af4a-47de1db1df3a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_de0d12bf-49d0-46fe-a412-361d5b3f8b48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-8e81-70f8-a6c6-c2423ee8437f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8e81-70f8-a6c6-c2423ee8437f",
        "storage_key": "property/6767906449165625/019d2709-8e81-70f8-a6c6-c2423ee8437f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cde-73c9-8bd4-d7f2b860d8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cde-73c9-8bd4-d7f2b860d8aa",
        "storage_key": "property/6767906449165625/019d2709-9cde-73c9-8bd4-d7f2b860d8aa.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9680e38d-4439-4d0d-a1d1-a58f42c02683",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 S Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9028-70ec-80b1-ff39e445ca18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9028-70ec-80b1-ff39e445ca18",
        "storage_key": "property/6767906449165625/019d2709-9028-70ec-80b1-ff39e445ca18.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cde-73c9-8bd4-d7f2b860d8aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cde-73c9-8bd4-d7f2b860d8aa",
        "storage_key": "property/6767906449165625/019d2709-9cde-73c9-8bd4-d7f2b860d8aa.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_03b7b060-79a7-41a1-9fc8-f3e31b189f10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-906a-74cd-a7f1-dfae1a2fae46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-906a-74cd-a7f1-dfae1a2fae46",
        "storage_key": "property/6767906449165625/019d2709-906a-74cd-a7f1-dfae1a2fae46.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0d696ce1-e3ad-4700-9585-52ad871e306b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-913d-72eb-a94e-9f3ff776862e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-913d-72eb-a94e-9f3ff776862e",
        "storage_key": "property/6767906449165625/019d2709-913d-72eb-a94e-9f3ff776862e.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4b52d9ef-70d7-4391-ad6a-f84ec3f3279b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9475-7568-acac-759e81a5f9eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9475-7568-acac-759e81a5f9eb",
        "storage_key": "property/6767906449165625/019d2709-9475-7568-acac-759e81a5f9eb.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b4f06605-46d6-4c5c-9200-e121e131be97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_466c9f21-4b76-4b33-bb71-f5b7f5519ba7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-94b6-7789-8785-bf35917fe152.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-94b6-7789-8785-bf35917fe152",
        "storage_key": "property/6767906449165625/019d2709-94b6-7789-8785-bf35917fe152.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb7-751c-bf73-7464266747f4",
        "storage_key": "property/6767906449165625/019d2709-9cb7-751c-bf73-7464266747f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a75c38c7-71af-4dea-8137-58fd3c01b6cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Darnaby Elementary School",
      "poi_type": "Education",
      "poi_address": "7625 E 87th St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://darnaby.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17731132405919378329&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "darnaby-elementary-school",
      "poi_latitude": "36.0395128",
      "poi_longitude": "-95.8915411",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4-KztvuNtocRmes9yPqiEfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9aa104df-3c5b-4734-8314-45ee08b1e952",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Union 6th/7th Grade Center",
      "poi_type": "Education",
      "poi_address": "10100 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-2747-723e-9f34-ddb9e62f8d9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2747-723e-9f34-ddb9e62f8d9f",
        "storage_key": "property/6767906449165625/019d7913-2747-723e-9f34-ddb9e62f8d9f.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357368135835625738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-6th-7th-grade-center",
      "poi_latitude": "36.0750199",
      "poi_longitude": "-95.8647424",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-357-4326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0q97M9mtocRCqk279gwfqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4d0a8439-c3b0-4c0e-a304-8eeac8937c8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-3cb1-753c-947e-b5112bfe2bb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3cb1-753c-947e-b5112bfe2bb6",
        "storage_key": "property/6767906449165625/019d7913-3cb1-753c-947e-b5112bfe2bb6.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_bbb74632-1909-4a85-b0c3-7fadb48bb56e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Union High School Freshman Academy",
      "poi_type": "Education",
      "poi_address": "7616 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-2caf-75ef-a055-50fe2ed133a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2caf-75ef-a055-50fe2ed133a5",
        "storage_key": "property/6767906449165625/019d7913-2caf-75ef-a055-50fe2ed133a5.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://ufa.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11673188432274153300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school-freshman-academy",
      "poi_latitude": "36.0524715",
      "poi_longitude": "-95.8526699",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-357-4324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNSlfnDaMtocRVF_mLQh__6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_00c8ab7e-c061-49dd-b50b-6b7dc46ebe9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-2c59-774f-98d8-4ad225c1a38a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2c59-774f-98d8-4ad225c1a38a",
        "storage_key": "property/6767906449165625/019d7913-2c59-774f-98d8-4ad225c1a38a.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0647a605-f54f-42a1-a660-bc7147741303",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-329b-70eb-9ab4-c1c5794f8f92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-329b-70eb-9ab4-c1c5794f8f92",
        "storage_key": "property/6767906449165625/019d7913-329b-70eb-9ab4-c1c5794f8f92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3374e601-fded-4b03-91e1-60d0466c6d46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Holland Hall Middle School",
      "poi_type": "Education",
      "poi_address": "5666 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-3506-745b-b8ea-44df1715d5ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3506-745b-b8ea-44df1715d5ef",
        "storage_key": "property/6767906449165625/019d7913-3506-745b-b8ea-44df1715d5ef.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.hollandhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=823686773055530440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "holland-hall-middle-school",
      "poi_latitude": "36.0447195",
      "poi_longitude": "-95.9145094",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-481-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF0bYLBGStocRyKUpisFSbgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_30dd97a0-b001-4a22-aa7a-962b0b63258c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Cascia Hall Preparatory School",
      "poi_type": "Education",
      "poi_address": "2520 S Yorktown Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-33f4-7516-8872-14d71d265b36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-33f4-7516-8872-14d71d265b36",
        "storage_key": "property/6767906449165625/019d7913-33f4-7516-8872-14d71d265b36.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.casciahall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1670198944159561507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cascia-hall-preparatory-school",
      "poi_latitude": "36.1269631",
      "poi_longitude": "-95.963356",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-746-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZByrbnstocRI_fcMhe9LRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4cf386bb-1d73-46cb-95de-1c46b5a78cd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "BOOKER T. WASHINGTON HIGH SCHOOL",
      "poi_type": "Education",
      "poi_address": "1514 E Zion St, Tulsa, OK 74106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-40de-76dc-ad29-b77fbd4feb99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-40de-76dc-ad29-b77fbd4feb99",
        "storage_key": "property/6767906449165625/019d7913-40de-76dc-ad29-b77fbd4feb99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://btw.tulsaschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17278098633414136121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "booker-t-washington-high-school",
      "poi_latitude": "36.1886802",
      "poi_longitude": "-95.9708215",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 918-925-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhYPqiIJ-1YcROdHP7ikjyO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_33b0c678-7a2a-45ce-97b7-24244e9ef7e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Deborah Brown Community School",
      "poi_type": "Education",
      "poi_address": "2 S Elgin Ave, Tulsa, OK 74120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-429b-7538-aa7b-3e3417e4904e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-429b-7538-aa7b-3e3417e4904e",
        "storage_key": "property/6767906449165625/019d7913-429b-7538-aa7b-3e3417e4904e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.dbcschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8140959315138694156&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "deborah-brown-community-school",
      "poi_latitude": "36.1570332",
      "poi_longitude": "-95.9895991",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-425-1407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFV_c8YHrtocRDMy_TV1_-nA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_46a51756-db6f-4a7a-9da0-6a77620f6078",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Peace Academy",
      "poi_type": "Education",
      "poi_address": "4620 S Irvington Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-488b-707a-940a-5726879c69c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-488b-707a-940a-5726879c69c2",
        "storage_key": "property/6767906449165625/019d7913-488b-707a-940a-5726879c69c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://patulsa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13057648211272518822&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peace-academy",
      "poi_latitude": "36.096653",
      "poi_longitude": "-95.911935",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-627-1040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIcMahL2StocRpszpot0VNrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_059d1df6-16ac-46ba-9b17-1fa8feb7a0d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Riverfield Country Day School",
      "poi_type": "Education",
      "poi_address": "2433 W 61st St, Tulsa, OK 74132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-4fc5-71fa-8edc-6e3807d55077.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4fc5-71fa-8edc-6e3807d55077",
        "storage_key": "property/6767906449165625/019d7913-4fc5-71fa-8edc-6e3807d55077.webp",
        "width": 1280,
        "height": 786
      },
      "poi_business_url": "http://riverfield.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3956653813819445514&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverfield-country-day-school",
      "poi_latitude": "36.0781351",
      "poi_longitude": "-96.0196231",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-446-3553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b2e-770a-93d3-b56caa1b3f04",
        "storage_key": "property/6767906449165625/019cfb47-4b2e-770a-93d3-b56caa1b3f04.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe78Px_uUtocRChHnL67b6DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f2abc299-aef4-44a7-aa70-ee9baebed974",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Asian Fusion restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6565 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "A restaurant featuring an array of Asian-inspired, fast-casual dishes in a family-friendly setting.",
      "poi_long_description": "People say this Asian restaurant serves delicious Chinese food, including stir fry, orange chicken, and deep-fried sushi. They highlight the fresh, hot, and tasty food, and the generous portions. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-53bd-75de-9b01-8883943684e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-53bd-75de-9b01-8883943684e7",
        "storage_key": "property/6767906449165625/019d7913-53bd-75de-9b01-8883943684e7.webp",
        "width": 1280,
        "height": 965
      },
      "poi_business_url": "http://www.asianfusiontulsaok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2839418634134511922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "asian-fusion-restaurant",
      "poi_latitude": "36.0611888",
      "poi_longitude": "-95.9011859",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-835-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4bc1-7167-8324-6a81c039623d",
        "storage_key": "property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-3A13aStocRMmE2MDSkZyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_b0c91c22-3ef1-4bde-b642-b7fd9d147ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "4651 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "People say this seafood restaurant serves delicious Bang Bang shrimp, Imperial Cod, and Brussels sprouts. They highlight the excellent service, welcoming atmosphere, and tasty complimentary bread. They also like the attentive staff and the perfect music for the occasion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-53bd-75de-9b01-8574f5806972.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-53bd-75de-9b01-8574f5806972",
        "storage_key": "property/6767906449165625/019d7913-53bd-75de-9b01-8574f5806972.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/oklahoma/broken-arrow/4651-w.-kenosha-street?y_source=1_MTU1MDI2OTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058823268018440839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "36.059982",
      "poi_longitude": "-95.8478642",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-252-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4bc1-7167-8324-6a81c039623d",
        "storage_key": "property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wz1zUiMtocRh0oQjCvVeJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_60eaa9f1-d109-4e9b-a2ef-86fc1550bdae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Siegi's Sausage Factory",
      "poi_type": "Restaurants",
      "poi_address": "8104 S Sheridan Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Restaurant & market offering housemade sausages & homestyle German-Austrian fare in relaxed digs.",
      "poi_long_description": "People say this restaurant serves delicious German food, including sausages, schnitzel, and goulash. They highlight the authentic flavors, generous portions, and reasonable prices. They also like the homey and calm atmosphere, and the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-5d93-70ba-816e-888a74912884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5d93-70ba-816e-888a74912884",
        "storage_key": "property/6767906449165625/019d7913-5d93-70ba-816e-888a74912884.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.siegis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14006480338056407640&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "siegi-s-sausage-factory",
      "poi_latitude": "36.045428",
      "poi_longitude": "-95.904789",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-492-8988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4bc1-7167-8324-6a81c039623d",
        "storage_key": "property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWYhxQ6StocRWGpYb6gDYcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c70a20f5-8522-4d8b-a191-26b86cbb4b1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Chimi's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6709 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Local chain serving classic Mexican fare & margaritas in a casual, traditional setting.",
      "poi_long_description": "People say this Mexican restaurant serves delicious enchiladas, flautas, and queso. They also highlight the good prices and great drinks.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-6119-7003-ac1d-fe9957535ff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6119-7003-ac1d-fe9957535ff1",
        "storage_key": "property/6767906449165625/019d7913-6119-7003-ac1d-fe9957535ff1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://chimismexican.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11458012329709581197&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chimi-s-mexican-restaurant",
      "poi_latitude": "36.0466938",
      "poi_longitude": "-95.9018863",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-960-2723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4bc1-7167-8324-6a81c039623d",
        "storage_key": "property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVCkbQmStocRjbNiuIEJA58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c146b02f-7db6-4193-8ceb-975161207a6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Kit's Takee-Outee",
      "poi_type": "Restaurants",
      "poi_address": "7994 S Sheridan Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual, take-out only joint dishing up Chinese standards such as sesame chicken.",
      "poi_long_description": "Diners say this Chinese meal takeaway offers delicious food, including Chocho beef, broccoli beef, and egg rolls, with large portions that are great for leftovers. They also highlight the friendly and helpful staff, and many appreciate the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-60ec-773d-8298-4a483ee35b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-60ec-773d-8298-4a483ee35b22",
        "storage_key": "property/6767906449165625/019d7913-60ec-773d-8298-4a483ee35b22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3459416050301400325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kit-s-takee-outee",
      "poi_latitude": "36.0477671",
      "poi_longitude": "-95.9047989",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-493-1180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4bc1-7167-8324-6a81c039623d",
        "storage_key": "property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVT3BgyStocRBfV_qJFQAjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_takeaway"
    },
    {
      "id": "custom_52a2c781-3e58-4744-88aa-ffade1986d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Nola's ...Creole & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "1334 E 15th St, Tulsa, OK 74120, USA",
      "poi_short_description": "Relaxed Cajun and Creole place with a chandelier-lit bar, old-timey photos, and Prohibition era cocktails.",
      "poi_long_description": "People say this Cajun restaurant serves delicious dishes like Voodoo Chicken, shrimp and grits, and boudin balls. They highlight the generous portions, reasonable prices, and fun, speakeasy-like atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-616d-7596-ab96-2371a50b445d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-616d-7596-ab96-2371a50b445d",
        "storage_key": "property/6767906449165625/019d7913-616d-7596-ab96-2371a50b445d.webp",
        "width": 1280,
        "height": 1218
      },
      "poi_business_url": "http://www.nolastulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=489749569356745618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nola-s-creole-cocktails",
      "poi_latitude": "36.1400087",
      "poi_longitude": "-95.9748442",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-779-7766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4bc1-7167-8324-6a81c039623d",
        "storage_key": "property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21HLopnstocRkstodqPwywY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_8d930c4f-1889-4eb7-a679-e9120f9d9b0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Sisserou's Caribbean Restaurant & Catering",
      "poi_type": "Restaurants",
      "poi_address": "107 N Boulder Ave C, Tulsa, OK 74103, USA",
      "poi_short_description": "Jerk chicken, stewed oxtail & mojitos served in a stylish, contemporary setting with valet parking.",
      "poi_long_description": "People say this Caribbean restaurant serves delicious oxtail stew, jerk chicken, and beef patties. They highlight the generous portions, fresh ingredients, and flavorful dishes. They also like the attentive service and pleasant atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-7032-748c-a5aa-4dfddc22ca5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7032-748c-a5aa-4dfddc22ca5d",
        "storage_key": "property/6767906449165625/019d7913-7032-748c-a5aa-4dfddc22ca5d.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.sisserousrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7131052098303193055&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sisserou-s-caribbean-restaurant-catering",
      "poi_latitude": "36.1575133",
      "poi_longitude": "-95.994075",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-576-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4bc1-7167-8324-6a81c039623d",
        "storage_key": "property/6767906449165625/019cfb47-4bc1-7167-8324-6a81c039623d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfW6TZ3rtocR328q-hmW9mI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "custom_0d92c0cc-a829-44de-87ab-aad91c8b0be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Kilkenny's Irish Pub",
      "poi_type": "Restaurants",
      "poi_address": "1413 E 15th St, Tulsa, OK 74120, USA",
      "poi_short_description": "Pub fare from sandwiches to fish dinners plus drinks & brunch in a traditional dark-wood setting.",
      "poi_long_description": "People say this Irish pub serves delicious fish and chips, scotch eggs, and bangers and mash. They highlight the generous portions, reasonable prices, and authentic Irish atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-6cdd-736d-bb54-bf9352e70083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6cdd-736d-bb54-bf9352e70083",
        "storage_key": "property/6767906449165625/019d7913-6cdd-736d-bb54-bf9352e70083.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsairishpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5796738057828299928&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kilkenny-s-irish-pub",
      "poi_latitude": "36.1407071",
      "poi_longitude": "-95.9728385",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-582-8282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-a9f3-7547-ad85-ae19728b4948.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-a9f3-7547-ad85-ae19728b4948",
        "storage_key": "property/6767906449165625/019d7913-a9f3-7547-ad85-ae19728b4948.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5af5ZnstocRmPTXGI0mclA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "custom_eddcfb86-88a0-4e80-956c-9bb615000e96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Square one center",
      "poi_type": "Entertainment",
      "poi_address": "6707 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-6ff9-722f-922b-fb7619e75943.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6ff9-722f-922b-fb7619e75943",
        "storage_key": "property/6767906449165625/019d7913-6ff9-722f-922b-fb7619e75943.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4767096569763649494&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "square-one-center",
      "poi_latitude": "36.046524",
      "poi_longitude": "-95.9021557",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b31-763e-af03-6c9e2c11823f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b31-763e-af03-6c9e2c11823f",
        "storage_key": "property/6767906449165625/019cfb47-4b31-763e-af03-6c9e2c11823f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0yV8bwmStocR1te-shIhKEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c0eb5b42-8644-4fc9-a8b9-c25dc63af085",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Chuck E. Cheese",
      "poi_type": "Entertainment",
      "poi_address": "7108 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Kid-friendly chain known for its arcade games, pizza parties & play zones.",
      "poi_long_description": "Some parents say this pizza restaurant offers great arcade games and is a popular spot for birthday parties, with many mentioning the friendly and helpful staff.\n\nOther reviews mention the prices can be expensive and the place can be overcrowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-6faa-71bb-abd5-66eee346207f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6faa-71bb-abd5-66eee346207f",
        "storage_key": "property/6767906449165625/019d7913-6faa-71bb-abd5-66eee346207f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chuckecheese.com/tulsa-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=14792054641861552020&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuck-e-cheese",
      "poi_latitude": "36.0600806",
      "poi_longitude": "-95.8871337",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-252-9661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b41-71ec-b521-87dfa32e738a",
        "storage_key": "property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWVEAlpGNtocRlGdTOlPvR80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_1995e564-808f-4732-ae39-906df1a709fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "BounceU Tulsa Kids Birthdays and More",
      "poi_type": "Entertainment",
      "poi_address": "8922 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Indoor playground featuring bounce houses, inflatable toys and interactive digital games, plus pizza.",
      "poi_long_description": "People say this children's amusement center offers a fun and engaging experience with bounce houses, obstacle courses, and giant blocks. They highlight the easy and stress-free birthday party experience, with staff handling everything from food service and gift distribution to cleanup. They also like the friendly, attentive, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-79b7-767a-adef-f3d6c1cfc3c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-79b7-767a-adef-f3d6c1cfc3c1",
        "storage_key": "property/6767906449165625/019d7913-79b7-767a-adef-f3d6c1cfc3c1.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.bounceu.com/tulsa-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=3547179287943316684&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bounceu-tulsa-kids-birthdays-and-more",
      "poi_latitude": "36.0337267",
      "poi_longitude": "-95.8879091",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-249-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b41-71ec-b521-87dfa32e738a",
        "storage_key": "property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUw9-xuKNtocRzAR8xMQcOjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_34a36aee-6d95-42ab-a9b5-f59adae8d6c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Southern Hills Country Club",
      "poi_type": "Entertainment",
      "poi_address": "2636 E 61st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Exclusive golf course complex that's known for hosting major championships for golf.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-7bc0-7692-92c3-20bcf1d4650b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7bc0-7692-92c3-20bcf1d4650b",
        "storage_key": "property/6767906449165625/019d7913-7bc0-7692-92c3-20bcf1d4650b.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.southernhillscc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451616975063633757&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "southern-hills-country-club",
      "poi_latitude": "36.0744607",
      "poi_longitude": "-95.9547711",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-492-3351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b41-71ec-b521-87dfa32e738a",
        "storage_key": "property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69nFggeTtocRXU8oQsEIqEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_d1e90abc-7703-4407-8489-a7da748ab071",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-8406-73aa-858c-06309a0bc690.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8406-73aa-858c-06309a0bc690",
        "storage_key": "property/6767906449165625/019d7913-8406-73aa-858c-06309a0bc690.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-abb7-7118-99f6-153e9837e483.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-abb7-7118-99f6-153e9837e483",
        "storage_key": "property/6767906449165625/019d7913-abb7-7118-99f6-153e9837e483.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1a2a0072-a911-4637-9ce7-d964a9254416",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Gilcrease Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 N Gilcrease Museum Rd, Tulsa, OK 74127, USA",
      "poi_short_description": "Museum housing extensive collections of art & artifacts of the American West & Native Americans.",
      "poi_long_description": "People say this art museum offers thoughtfully curated exhibits that provide deep insight into American history, Native American art, and the history of the West. They highlight the beautiful and peaceful grounds, and the well-organized and engaging experience. They also like the knowledgeable and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-84e2-7509-9a24-524def496540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-84e2-7509-9a24-524def496540",
        "storage_key": "property/6767906449165625/019d7913-84e2-7509-9a24-524def496540.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "http://gilcrease.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13539514656066097772&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gilcrease-museum",
      "poi_latitude": "36.1742658",
      "poi_longitude": "-96.0210402",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 918-596-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-abb7-7118-99f6-153e9837e483.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-abb7-7118-99f6-153e9837e483",
        "storage_key": "property/6767906449165625/019d7913-abb7-7118-99f6-153e9837e483.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgf7O0rXrtocRbNIDItgE5rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_faeedaf1-96fe-4640-a0d8-894de1cce73f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "The Cave House",
      "poi_type": "Entertainment",
      "poi_address": "1623 Charles Page Blvd, Tulsa, OK 74127, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this tourist attraction offers a unique and fascinating experience with its whimsical, cave-like exterior and quirky, eclectic interior. They also highlight the knowledgeable and passionate management who provides captivating tours, sharing stories about the house's history and rumored connections to prohibition-era tunnels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-888c-7018-971d-85f2a9d3b10e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-888c-7018-971d-85f2a9d3b10e",
        "storage_key": "property/6767906449165625/019d7913-888c-7018-971d-85f2a9d3b10e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cavehousetulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2036454794667285882&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-cave-house",
      "poi_latitude": "36.1517261",
      "poi_longitude": "-96.0112601",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-378-1952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b41-71ec-b521-87dfa32e738a",
        "storage_key": "property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5fkfgzrtocRet1IndjwQhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_4cc322f1-53ed-45ed-bdc0-e9d070daaf3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "BOK Center",
      "poi_type": "Entertainment",
      "poi_address": "200 S Denver Ave., Tulsa, OK 74103, USA",
      "poi_short_description": "High-design, eco-conscious arena hosting professional sports plus concerts & festivals.",
      "poi_long_description": "Visitors say this arena hosts exciting hockey games and concerts, and they appreciate the friendly and helpful staff. They also highlight the clean facilities and easy access to parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d7913-8abd-700d-b11c-da4c2df16533.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8abd-700d-b11c-da4c2df16533",
        "storage_key": "property/6767906449165625/019d7913-8abd-700d-b11c-da4c2df16533.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bokcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467435354223455802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bok-center",
      "poi_latitude": "36.1527314",
      "poi_longitude": "-95.996545",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-894-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-4b41-71ec-b521-87dfa32e738a",
        "storage_key": "property/6767906449165625/019cfb47-4b41-71ec-b521-87dfa32e738a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ966yH3frtocROq4G5Bnx5bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_578cb25c-35db-4465-8264-9f3c3e9196ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "poi_name": "Señor Tequila Mexican Grill and Cantina",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "se-or-tequila-mexican-grill-and-cantina",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_800c6987c71d58a30d1a2210",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_16f5a04c9a6f449ebeec455d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0daaabfdab2ba89676991f67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ae1a51f08a53f88c42d67546",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ad2ad8a9eb16a8f672c77b9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_093e44bb1d5d67906015457d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e668645b-43ad-4eca-acab-e3395b58ddb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "rating": "5.0",
      "name": "Brenda Larrabee",
      "text": "Cody is the maintenance man that comes to my apartment.  He is very kind, professional and does a great job.  I am always very comfortable with him being in the apartment whether I am here or not.  Does a great job!",
      "date": "2025-09-08",
      "title": ""
    },
    {
      "id": "custom_0b5453b5-d83d-4a96-ba3f-4359235e95be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "rating": "5.0",
      "name": "Rick Ryan",
      "text": "Lived on this property for 18 years and have never had an issue. It's nice and quiet here. The one thing I would like to see is a shaded area in the dog park, perhaps a canopy of some sort.",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_5d9dcb28-05ca-472a-a059-216ee20842d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "rating": "5.0",
      "name": "Dan Baxter",
      "text": "Our visit to Sheridan Pond was excellent. Jasmine answered all of our questions and have us a tour of the model apartment. It is the top of our list so far.",
      "date": "2025-09-11",
      "title": ""
    },
    {
      "id": "custom_a6f0c67c-9150-4660-8dec-6ab55c222c2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "rating": "5.0",
      "name": "tonnya cress",
      "text": "Had an issue where a/c drain line was clogged and caused an overflow....called in the problem and being urgent it was taken care of by maintenance within 30 minutes.  Very responsive and this was a Saturday.  Very pleased.",
      "date": "2025-08-24",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_2ca35daa-ac35-40ed-a5e9-3591ad52a531",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-cbb0-7300-bf6c-1bde2adcf8da.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a modern kitchen with granite countertops and stainless steel appliances.",
        "public_id": "019cfb47-cbb0-7300-bf6c-1bde2adcf8da",
        "storage_key": "property/6767906449165625/019cfb47-cbb0-7300-bf6c-1bde2adcf8da.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Sheridan Pond Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6304c6bd3535377cb72ee17a"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-8631-70c5-8267-c2ba4837cdcb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "sheridan-pond",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625"
    },
    {
      "lead_collector_id": "019cf79e-86a6-7594-8f70-900ab1ed0b3e",
      "lead_source": "LANDING_PAGE",
      "name": "sheridan-pond",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-south-tulsa",
      "search_query": "apartments with in-unit laundry in South Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in South Tulsa",
      "h2_subtitle": "Discover the convenience of apartments with in-unit laundry in South Tulsa. Enjoy a lifestyle of ease at Sheridan Pond with top-notch amenities at your doorstep.",
      "page_copy": "Located in the heart of South Tulsa, Sheridan Pond offers ideal living with spacious one, two, or three-bedroom apartments that include in-unit laundry facilities. This feature is just one of the many modern conveniences designed to simplify your life and allow you more time to enjoy our sparkling pool, relaxing clubhouse, or state-of-the-art fitness center.\n\nExperience ultimate comfort and convenience in our community, where each apartment is cable ready and equipped with a dishwasher, yard, and patio. Need to work from home? Our business center is perfect for that too. At Sheridan Pond, it's not just about having a home; it's about embracing a lifestyle where everything you need is just a step away. Don't miss out on experiencing these amazing amenities. Check availability or schedule a tour of our apartments with in-unit laundry today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in South Tulsa",
      "seo_description": "Explore Sheridan Pond's apartments with in-unit laundry in South Tulsa. Enjoy convenience and comfort with modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-tulsa-ok",
      "search_query": "air conditioned apartments in Tulsa OK",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Tulsa, OK",
      "h2_subtitle": "Stay cool and comfortable in our air conditioned apartments in Tulsa, OK. Discover exceptional living at Sheridan Pond with premium amenities close by.",
      "page_copy": "Sheridan Pond in Tulsa, OK, offers a comfortable retreat with air conditioned apartments, perfect for escaping the Oklahoma heat. Each of our one, two, or three-bedroom floor plans includes modern amenities designed to enhance your living experience. From our refreshing sparkling pool to the fully-equipped fitness center and inviting clubhouse, there's something for everyone.\n\nIn addition to air conditioning, residents enjoy a dishwasher, cable readiness, private patios, and a lush yard. Whether you're working from the business center or relaxing at home, Sheridan Pond ensures a high-quality lifestyle. Embrace this fantastic community and make the most of South Tulsa living. Check availability or plan a tour of our air conditioned apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Tulsa, OK",
      "seo_description": "Experience comfort in air conditioned apartments at Sheridan Pond, Tulsa, OK. Enjoy modern amenities and a prime location. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "sheridan-pond-apartments-with-swimming-pool",
      "search_query": "Sheridan Pond apartments with swimming pool",
      "category": "Amenity",
      "h1_title": "Sheridan Pond Apartments With Swimming Pool",
      "h2_subtitle": "Dive into luxury at Sheridan Pond with our inviting swimming pool. Experience the perfect blend of comfort and recreation at these charming Tulsa apartments.",
      "page_copy": "At Sheridan Pond Apartments, we take pride in offering a remarkable lifestyle enhanced by our sparkling swimming pool, perfect for relaxation and social gatherings. Located in vibrant South Tulsa, these contemporary one, two, or three-bedroom apartments provide a comfortable living experience with a range of modern amenities.\n\nBeyond the inviting swimming pool, residents enjoy convenient features such as a business center, fitness center, and cozy clubhouse. Apartments are equipped with essentials like a dishwasher, cable readiness, and private patio or yard. Discover the delightful balance of recreation and comfort that Sheridan Pond offers and schedule a tour to see it firsthand. Find your ideal home in an apartment that complements both your lifestyle and leisure at Sheridan Pond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Pond Apts With Swimming Pool",
      "seo_description": "Explore Sheridan Pond Apartments, where you can unwind in our swimming pool amidst modern amenities. Located in vibrant South Tulsa. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-tulsa-oklahoma",
      "search_query": "apartments with fitness center in Tulsa Oklahoma",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Tulsa",
      "h2_subtitle": "Stay active at our apartments with a fitness center in Tulsa, Oklahoma. Sheridan Pond offers a well-equipped facility for your health and wellness needs.",
      "page_copy": "For those seeking an active lifestyle in Tulsa, Oklahoma, Sheridan Pond provides apartments with a state-of-the-art fitness center. Our community offers the perfect setting, featuring spacious floor plans and a variety of amenities designed to enrich your daily life. Whether you choose a one, two, or three-bedroom apartment, you'll find a home equipped with cable readiness, dishwashers, and private patios or yards.\n\nIn addition to the fitness center, residents enjoy access to a sparkling pool, a convenient business center, and a welcoming clubhouse. Sheridan Pond's location in South Tulsa balances tranquility with easy access to urban conveniences. Embrace a lifestyle of health and convenience by exploring our available units today. Schedule a tour to experience these wonderful amenities firsthand!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Fitness Center in Tulsa, OK",
      "seo_description": "Discover Sheridan Pond's apartments with a fitness center in Tulsa, OK. Enjoy an active lifestyle with top amenities and spacious living. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "sheridan-pond-gated-community-apartments",
      "search_query": "Sheridan Pond gated community apartments",
      "category": "Amenity",
      "h1_title": "Sheridan Pond Gated Community Apartments",
      "h2_subtitle": "Experience security and serenity at Sheridan Pond gated community apartments. Enjoy top-notch amenities in a peaceful South Tulsa location.",
      "page_copy": "Welcome to Sheridan Pond, where gated community living meets modern comforts in Tulsa, Oklahoma. Our charming apartments are nestled within a secure environment, thoughtfully designed to offer peace of mind along with a variety of amenities. Choose from spacious one, two, or three-bedroom layouts equipped with conveniences like cable readiness, dishwashers, and private patios or yards.\n\nAt Sheridan Pond, residents enjoy exclusive access to our sparkling swimming pool, fitness center, and business center. Our cozy clubhouse provides a perfect gathering spot for relaxation and socialization within our gated premises. Located in South Tulsa, Sheridan Pond offers the serenity of community living while being just minutes away from urban amenities. Discover the lifestyle that balances safety, comfort, and convenience. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Pond Gated Community Apts",
      "seo_description": "Enjoy secure living at Sheridan Pond gated community apartments in Tulsa, OK. Access modern amenities within a serene environment. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-tulsa-ok",
      "search_query": "one bedroom apartments Tulsa OK",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Discover your ideal one bedroom apartment in Tulsa, OK at Sheridan Pond. Enjoy modern amenities and a cozy living environment in a prime location.",
      "page_copy": "Looking for a comfortable living space in Tulsa, OK? Sheridan Pond offers charming one bedroom apartments perfect for those seeking a blend of style and convenience. Each apartment is thoughtfully designed with modern finishes and amenities such as cable readiness, a dishwasher, and a private patio or yard—all within a vibrant South Tulsa neighborhood.\n\nAt Sheridan Pond, residents can enjoy more than just a place to live. Our community features a sparkling swimming pool, a state-of-the-art fitness center, and a cozy clubhouse ideal for gatherings and relaxation. Whether you're working remotely in our business center or unwinding by the pool, Sheridan Pond provides the perfect setting for your lifestyle. Visit us today to explore our available one bedroom apartments and find the home that suits you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Tulsa, OK",
      "seo_description": "Find the perfect one bedroom apartment in Tulsa, OK at Sheridan Pond. Enjoy modern amenities and prime location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-south-tulsa",
      "search_query": "two bedroom apartments in South Tulsa",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Explore spacious two bedroom apartments in South Tulsa at Sheridan Pond. Enjoy comfort and convenience with our premium amenities.",
      "page_copy": "Experience the perfect combination of space and comfort at Sheridan Pond with our two bedroom apartments in South Tulsa. Designed to cater to modern lifestyles, these apartments feature cable readiness, a dishwasher, and private outdoor areas such as a patio or yard. Located in a vibrant community, Sheridan Pond provides a serene and inviting atmosphere.\n\nResidents of Sheridan Pond have access to a range of amenities that go beyond the apartment doors. Take advantage of our sparkling pool, fitness center, and comfortable clubhouse for social gatherings or relaxing downtime. With a business center available for work-from-home needs, Sheridan Pond is tailored to fit both professional and leisurely pursuits. Discover your next home in our welcoming community today. Schedule a tour to see why our two bedroom apartments stand out.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments South Tulsa",
      "seo_description": "Discover spacious two bedroom apartments in South Tulsa at Sheridan Pond. Enjoy modern amenities and a welcoming community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-74137",
      "search_query": "three bedroom apartments near 74137",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 74137",
      "h2_subtitle": "Find expansive three bedroom apartments near 74137 at Sheridan Pond. Enjoy family-friendly amenities within a serene community setting.",
      "page_copy": "Discover the ideal living space for growing families or those who crave extra room in our three bedroom apartments at Sheridan Pond, conveniently located near the 74137 area. Each apartment is designed with a spacious layout and modern conveniences like cable readiness, a dishwasher, and either a private patio or yard, offering comfort in a prime South Tulsa location.\n\nSheridan Pond isn't just a place to live—it's a community designed to enhance your lifestyle. Enjoy access to our sparkling pool, comprehensive fitness center, and inviting clubhouse, perfect for hosting gatherings or casual meetups. The business center offers a great space for remote work needs. Close to various dining and shopping options, Sheridan Pond provides a serene environment without compromising on convenience. Come experience the lifestyle you deserve in our three bedroom apartments near 74137. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 74137",
      "seo_description": "Explore three bedroom apartments near 74137 at Sheridan Pond. Offering spacious layouts and great amenities. Schedule a visit now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "apartments-near-oral-roberts-university-tulsa",
      "search_query": "apartments near oral roberts university tulsa",
      "category": "School",
      "h1_title": "Apartments Near Oral Roberts University",
      "h2_subtitle": "Looking for convenient apartments near Oral Roberts University? Sheridan Pond offers modern living options just a short distance away.",
      "page_copy": "Discover the ideal location for students and faculty with Sheridan Pond's apartments near Oral Roberts University in Tulsa. Our community offers a range of one, two, and three-bedroom floor plans designed for comfort and modern living. Each apartment features high-quality amenities like cable readiness, a dishwasher, and private outdoor spaces, creating a perfect home environment close to campus.\n\nAt Sheridan Pond, we prioritize a balanced lifestyle with on-site amenities including a sparkling swimming pool, a state-of-the-art fitness center, and a cozy clubhouse. Our business center is perfect for study sessions or remote work, making it easy to stay productive. Located in South Tulsa, Sheridan Pond is situated in a vibrant area with easy access to dining, shopping, and recreational options. Experience the convenience of living near Oral Roberts University—schedule a tour of our community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oral Roberts University",
      "seo_description": "Find modern apartments near Oral Roberts University at Sheridan Pond. Enjoy convenience and lifestyle amenities. Tour our South Tulsa apartments today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "apartments-close-to-tulsa-community-college-se-campus",
      "search_query": "apartments close to tulsa community college southeast campus",
      "category": "School",
      "h1_title": "Apartments Close to Tulsa Community College SE",
      "h2_subtitle": "Discover convenient living with apartments close to Tulsa Community College Southeast Campus at Sheridan Pond. Ideal for students and staff alike.",
      "page_copy": "Sheridan Pond offers the perfect living solution for those looking for apartments close to Tulsa Community College Southeast Campus. Our selection of one, two, and three-bedroom units are designed to cater to the needs of students and faculty, providing a comfortable and modern home environment. Enjoy amenities such as cable readiness, a dishwasher, and private spaces like a patio or yard, making Sheridan Pond a top choice for convenient campus living.\n\nIn addition to strategic location, Sheridan Pond provides an array of community amenities designed to enhance your lifestyle. Residents can unwind at the sparkling pool, maintain fitness goals at our well-equipped center, or utilize the business center for academic or remote work needs. Nestled in the heart of South Tulsa, our community offers easy access to local dining, shopping, and entertainment, making it a great place to balance school, work, and leisure. Schedule a tour today to see why students and staff love living at Sheridan Pond!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tulsa Community College SE",
      "seo_description": "Find apartments close to Tulsa Community College Southeast Campus at Sheridan Pond. Discover the perfect student-friendly living, just minutes from your classes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "apartments-near-ou-tulsa-south-tulsa",
      "search_query": "apartments near ou-tulsa south tulsa",
      "category": "School",
      "h1_title": "Apartments Near OU-Tulsa South Tulsa",
      "h2_subtitle": "Explore living options with apartments near OU-Tulsa in South Tulsa. Sheridan Pond offers convenience and comfort just around the corner.",
      "page_copy": "If you are seeking the perfect place to call home near OU-Tulsa in South Tulsa, Sheridan Pond opens its doors with welcoming one, two, and three-bedroom apartments. Designed with modern living in mind, our community offers a serene environment complete with contemporary amenities like cable readiness, dishwashers, and private patios or yards, making it the perfect spot for students and professionals alike.\n\nSheridan Pond is more than just a location; it’s a lifestyle. Enjoy access to a sparkling pool, a full-featured fitness center, and a welcoming clubhouse ideal for relaxation or study. Our business center adds convenience for those pursuing academic or work tasks. Situated in South Tulsa, our location provides quick access to shopping, dining, and recreation, making life here as convenient as it is enjoyable. Visit us today to explore why residents love calling Sheridan Pond home, just steps away from OU-Tulsa!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OU-Tulsa South Tulsa",
      "seo_description": "Find your home at Sheridan Pond with apartments near OU-Tulsa in South Tulsa. Offering modern amenities and an ideal location. Tour our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-south-tulsa",
      "search_query": "apartments near Saint Francis Hospital South Tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital South",
      "h2_subtitle": "Seeking apartments near Saint Francis Hospital South Tulsa? Sheridan Pond offers a comfortable lifestyle just minutes from the hospital.",
      "page_copy": "Sheridan Pond provides an excellent option for those searching for apartments near Saint Francis Hospital South in Tulsa. Offering spacious one, two, and three-bedroom units, our community ensures comfortable living with modern amenities. Residents enjoy the convenience of a dishwasher, cable ready apartments, and the added benefit of private yards or patios, perfectly suited for professionals and hospital staff seeking nearby accommodations.\n\nOur community doesn’t just offer proximity to Saint Francis Hospital; we enhance your living experience with a variety of amenities. Take a dip in our sparkling pool, work out in our fully-equipped fitness center, or take advantage of our business center for all your professional needs. Located in the vibrant South Tulsa area, Sheridan Pond also places you near dining, shopping, and entertainment venues, making life both convenient and enjoyable. Schedule a tour today and discover why our residents appreciate the blend of comfort and location Sheridan Pond offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital South",
      "seo_description": "Discover Sheridan Pond Apartments near Saint Francis Hospital South Tulsa. Ideal location plus modern amenities for healthcare professionals. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "sheridan-pond-apartments-near-hillcrest-south-tulsa",
      "search_query": "Sheridan Pond apartments near Hillcrest South Tulsa",
      "category": "Hospital",
      "h1_title": "Sheridan Pond Near Hillcrest South Tulsa",
      "h2_subtitle": "Explore Sheridan Pond apartments near Hillcrest South Tulsa, offering modern living and convenience just minutes away from the hospital.",
      "page_copy": "Sheridan Pond is ideally located for those looking for apartments near Hillcrest South in Tulsa. Our selection of one, two, and three-bedroom floor plans cater to various lifestyles, making it a prime choice for medical professionals and hospital staff seeking nearby housing. With modern amenities such as cable ready apartments, dishwashers, and private patios or yards, Sheridan Pond effortlessly combines comfort with convenience.\n\nBeyond a great location, our community provides excellent amenities that complement a busy lifestyle. Enjoy access to a refreshing pool, a state-of-the-art fitness center, and a relaxing clubhouse. Additionally, our business center is the perfect spot for catching up on work. Nestled in the lively South Tulsa area, residents benefit from easy access to shopping, dining, and entertainment options. Visit us today and find out why Sheridan Pond is the perfect setting for those working at Hillcrest South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Pond Apts Near Hillcrest South Tulsa",
      "seo_description": "Find Sheridan Pond apartments near Hillcrest South Tulsa. Enjoy modern homes and convenient amenities, just steps from work. Tour Sheridan Pond today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-tulsa",
      "search_query": "apartments near Rhema Park Tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park Tulsa",
      "h2_subtitle": "Discover Sheridan Pond, apartments near Rhema Park in Tulsa. Enjoy a lifestyle of convenience and modern amenities just a short drive away.",
      "page_copy": "Nestled in the heart of South Tulsa, Sheridan Pond offers idyllic living just moments from Rhema Park. Whether you're looking for a one, two, or three-bedroom apartment, Sheridan Pond provides a perfect mix of modern amenities and convenient location. Ideal for those who appreciate outdoor activities, our community places you near Rhema Park, a beautiful setting for exercise, relaxation, and recreation.\n\nWhen you call Sheridan Pond home, you enjoy amenities like a sparkling swimming pool, well-equipped fitness center, and a cozy clubhouse perfect for gathering with friends. Each apartment is designed with convenience in mind, featuring essentials such as cable readiness and dishwashers, with select units offering private patios or yards. Situated in a vibrant neighborhood, you'll find yourself close to dining, shopping, and entertainment venues. Come tour Sheridan Pond today and experience why so many choose us for their ideal living near Rhema Park in Tulsa!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rhema Park Tulsa",
      "seo_description": "Explore Sheridan Pond apartments near Rhema Park Tulsa. Offering modern living with easy access to parks, shopping, and dining. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "sheridan-pond-apartments-close-to-lafortune-park",
      "search_query": "Sheridan Pond apartments close to LaFortune Park",
      "category": "Park",
      "h1_title": "Sheridan Pond Apartments by LaFortune Park",
      "h2_subtitle": "Looking for Sheridan Pond apartments close to LaFortune Park? Enjoy a unique blend of modern amenities and proximity to Tulsa's green oasis.",
      "page_copy": "Sheridan Pond offers an exceptional living experience for those seeking apartments close to LaFortune Park in Tulsa. Our comfortable one, two, and three-bedroom apartments are perfect for those who love to enjoy the outdoors, with the expansive LaFortune Park just a short distance away. This prime location provides you with easy access to beautiful trails, golfing, and recreational opportunities.\n\nAt Sheridan Pond, you'll find thoughtfully designed apartments that cater to a modern lifestyle. Enjoy in-unit amenities like dishwashers and cable readiness, alongside community features such as a sparkling pool, a state-of-the-art fitness center, and a welcoming clubhouse. Whether you’re relaxing in your apartment with a private patio or exploring nearby local attractions, Sheridan Pond positions you perfectly for a balanced and active lifestyle in South Tulsa. Visit us to learn more about the advantages of living close to LaFortune Park at Sheridan Pond today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Pond Apts Near LaFortune Park",
      "seo_description": "Discover Sheridan Pond apartments near LaFortune Park in Tulsa. Enjoy modern amenities and outdoor recreation. Book a tour of Sheridan Pond today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "elam-park-nearby-apartments-south-tulsa",
      "search_query": "Elam Park nearby apartments South Tulsa",
      "category": "Park",
      "h1_title": "Elam Park Nearby Apartments in South Tulsa",
      "h2_subtitle": "Explore Sheridan Pond, offering nearby apartments close to Elam Park in South Tulsa. Enjoy peaceful living with convenient access.",
      "page_copy": "Sheridan Pond is your ideal choice for nearby apartments to Elam Park in South Tulsa. Our community offers spacious one, two, and three-bedroom apartments designed with modern living in mind. With Elam Park just around the corner, you have the perfect place to enjoy serene walks, outdoor activities, and family picnics, enhancing your lifestyle with nature's beauty.\n\nLiving at Sheridan Pond means having access to top-notch amenities that complement your lifestyle. Relax by the sparkling pool, get your workouts done in our fully equipped fitness center, or host events in our quaint clubhouse. Each apartment is ready to move in, featuring cable readiness and the comfort of dishwashers, with some units boasting private patios or spacious yards. Situated in vibrant South Tulsa, you'll enjoy proximity to dining, shopping, and entertainment destinations. Discover the comfort and convenience of Sheridan Pond, where Elam Park's serenity is just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elam Park Nearby Apartments in South Tulsa",
      "seo_description": "Find Sheridan Pond, offering nearby apartments to Elam Park in South Tulsa. Enjoy modern living with park access. Tour Sheridan Pond today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "hunter-park-residential-living-tulsa-ok",
      "search_query": "Hunter Park residential living Tulsa OK",
      "category": "Park",
      "h1_title": "Hunter Park Residential Living in Tulsa, OK",
      "h2_subtitle": "Discover Sheridan Pond, offering ideal residential living near Hunter Park in Tulsa, OK. Enjoy spacious layouts and modern amenities close by.",
      "page_copy": "Experience premier residential living near Hunter Park at Sheridan Pond in Tulsa, OK. Our community offers beautifully designed one, two, and three-bedroom apartments, providing a perfect blend of comfort and convenience. Located just a short drive from Hunter Park, residents can enjoy everything from scenic nature trails to family-friendly recreational facilities.\n\nSheridan Pond enhances your living experience with top-notch amenities including a business center, sparkling swimming pool, and a fully-equipped fitness center. Apartments are equipped with modern conveniences such as dishwashers and cable readiness, with select units featuring private patios or spacious yards. Ideally situated in South Tulsa, Sheridan Pond grants easy access to a vibrant neighborhood filled with dining, entertainment, and shopping options. Embark on a fulfilling lifestyle in Tulsa by choosing Sheridan Pond, where Hunter Park's natural beauty and exciting opportunities await.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hunter Park Residential Living in Tulsa, OK",
      "seo_description": "Explore Sheridan Pond for residential living near Hunter Park in Tulsa, OK. Enjoy spacious apartments with modern amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165625",
      "source": "generator",
      "page_item_url": "haikey-creek-park-apartments-74137",
      "search_query": "Haikey Creek Park apartments 74137",
      "category": "Park",
      "h1_title": "Haikey Creek Park Apartments in 74137",
      "h2_subtitle": "Find your home at Sheridan Pond, offering apartments near Haikey Creek Park in the 74137 area. Enjoy a blend of modern living and outdoor access.",
      "page_copy": "Welcome to Sheridan Pond, where you'll find exceptional apartments conveniently located near Haikey Creek Park in the 74137 zip code. Our community offers spacious one, two, and three-bedroom floor plans, ideal for those who cherish both indoor comfort and outdoor relaxation. Haikey Creek Park is just a short trip away, offering an array of activities including walking trails and picnic areas, perfect for weekend adventures.\n\nAt Sheridan Pond, you'll enjoy a host of modern amenities designed for your convenience and enjoyment. Relax in our sparkling swimming pool, stay fit in our well-equipped fitness center, or take advantage of our business center for remote work needs. Your apartment will come cable-ready, complete with a dishwasher, and some units even offer the luxury of a private patio or yard. Situated in the heart of South Tulsa, experience the perfect lifestyle balance at Sheridan Pond, with Haikey Creek Park as your natural neighbor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, armchair, and coffee table.",
        "public_id": "019cfb47-1c40-755e-a13f-63a33875246b",
        "storage_key": "property/6767906449165625/019cfb47-1c40-755e-a13f-63a33875246b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Haikey Creek Park Apartments in 74137",
      "seo_description": "Discover Sheridan Pond apartments near Haikey Creek Park in the 74137 area. Enjoy modern living and nearby park access. Contact us for a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5212"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-BDP8G8BN2S"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151717"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/sheridan-pond/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WM7SZCK4"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d1bd9-af8a-76e9-9afc-52d8c2b53ea7.webp"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "43510d08-c3b1-4c4a-8e4c-38c4ce262c5b"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-341-1542"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651dbc34d2df3325aca6ad"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjFlUnBBQzJ3cUxISDN4aklpTk04UHc9PSIsInZhbHVlIjoiQmVRanZaQkhzSGlUTXZoWVJ2QXBWdz09IiwibWFjIjoiZjFiNTc4MGY2M2Y4YTVjZTAzYTg3ODliMDYzYmRmMzY5MjdjZWQzNjBjMTMwMGEzY2VlMmJkNTEyZjFkZWE3OSJ9"
    }
  ],
  "custom_qb_id": "5212",
  "custom_ga4_id": "G-BDP8G8BN2S",
  "custom_repli_id": "10041151717",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/sheridan-pond/register/",
  "custom_google_gtm_id": "GTM-WM7SZCK4",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019d1bd9-af8a-76e9-9afc-52d8c2b53ea7.webp",
  "custom_rentgrata_property_id": "43510d08-c3b1-4c4a-8e4c-38c4ce262c5b",
  "custom_ppc_tracking_phone_number": "844-341-1542",
  "custom_residentboost_apartment_id": "64651dbc34d2df3325aca6ad",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjFlUnBBQzJ3cUxISDN4aklpTk04UHc9PSIsInZhbHVlIjoiQmVRanZaQkhzSGlUTXZoWVJ2QXBWdz09IiwibWFjIjoiZjFiNTc4MGY2M2Y4YTVjZTAzYTg3ODliMDYzYmRmMzY5MjdjZWQzNjBjMTMwMGEzY2VlMmJkNTEyZjFkZWE3OSJ9"
};

export const generatedAt = '2026-08-27T21:36:40.420Z';
